import { render, staticRenderFns } from "./EnigmaBody.vue?vue&type=template&id=4ed4b2e0&scoped=true&"
import script from "./EnigmaBody.vue?vue&type=script&lang=js&"
export * from "./EnigmaBody.vue?vue&type=script&lang=js&"
import style0 from "./EnigmaBody.vue?vue&type=style&index=0&id=4ed4b2e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed4b2e0",
  null
  
)

export default component.exports